import DateRangeFilter from './date-range-filter';

/***
 * A filter for a date range to see if a given date exists between a start and end date.
 */
const dateRange = angular
    .module('FacilityData.Common.DateRange', [])
    .filter('dateRange', DateRangeFilter.filter)
    .name;

export default dateRange;


// WEBPACK FOOTER //
// ./app/common/date-range/date-range.js